import React from 'react'
import blogimageone from '../../Assets/blogone.svg'
import blogimagetwo from '../../Assets/blogtwo.svg'
import blogimagethree from '../../Assets/blogthree.svg'
import AOS from "aos";
import { useEffect } from 'react';
import "aos/dist/aos.css";

const Blog = () => {

	useEffect(() => {
		AOS.init({
		  disable: "phone",
		  duration: 700,
		//   easing: "ease-out-cubic",
		});
	  }, []);


		
  return (
    <div className='blog-main-section'>
			<div className="container-main">
				<div className="row">
					<div className="col-lg-12">
						<div className="main-heading-blog">
							<h1 className='blog-heading mb-0'>Latest  Blogs</h1>
						</div>
					</div>
					<div className="col-lg-4 col-md-6	 col-sm-6">
						<div className="blog-box" data-aos="fade-down">
							<img src={blogimageone} className='blog-image' alt="" />
							<div className="blog-content-dv">
								<h4 className='blog-heading-txt'>The Essence of Empowerment: Transforming Lives at Q-Garden</h4>
								<p className='mb-0 blog-sub-textt'>At Q-Garden, education is more than just academics — it's a transformative journey that shapes confident, independent, and empowered women. Our institution provides a nurturing environment where women are encouraged to develop life skills, leadership qualities, and moral values essential for success in both personal and professional realms.</p>
							</div>
						</div>
					</div>
					<div className="col-lg-4 col-md-6	 col-sm-6">
						<div className="blog-box" data-aos="fade-down">
							<img src={blogimagetwo} className='blog-image' alt="" />
							<div className="blog-content-dv">
								<h4 className='blog-heading-txt'>Why Q-Garden is the Ideal Place for Holistic Learning</h4>
								<p className='mb-0 blog-sub-textt'>The world is rapidly evolving,  At Q-Garden, we understand the importance of a balanced education that blends knowledge, values, and practical skills. Our dynamic curriculum caters to various learning paths, ensuring that every woman finds her niche and achieves success. From academic excellence to life lessons that promote self-reliance and ethical decision-making </p>
							</div>
						</div>
					</div>
					<div className="col-lg-4 col-md-6	 col-sm-6">
						<div className="blog-box" data-aos="fade-down">
							<img src={blogimagethree} className='blog-image' alt="" />
							<div className="blog-content-dv">
								<h4 className='blog-heading-txt'>Cultivating the Future: Q-Garden's Commitment to Motherhood and Childhood</h4>
								<p className='mb-0 blog-sub-textt'>In today's fast-paced world, the essence of motherhood and childhood is often overlooked. Q-Garden takes pride in its mission to prepare women for the challenges of modern life while preserving the values of nurturing and compassion. By empowering women through education and personal development, we contribute to building strong families and communities.  </p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
  )
}

export default Blog